
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/contact",
      function () {
        return require("private-next-pages/page/[subdomain]/contact.tsx");
      }
    ]);
  